/**
 * Manager keys whose backend class extends LlmJudgeMetricBase. Used to gate
 * LLM-judge metrics out of the derived-metric parent picker (parents must be
 * deterministic).
 *
 * Mirror of `_compute_llm_judge_managers()` in
 * src/modules/metrics/derived_helpers.py — keep in sync until the
 * transport metrics view ships and projects `is_llm_judge` server-side, at
 * which point this file should be deleted in favor of consuming the
 * BE-derived field directly from the metrics resource.
 *
 * Audio LLM judges (manager_audio_llm_*) are intentionally excluded because
 * their backend classes extend AudioLlmJudgeBase (which itself extends
 * AudioMetricBase, not LlmJudgeMetricBase).
 */
const LLM_JUDGE_MANAGERS = new Set<string>([
  "manager_llm_binary",
  "manager_agentic_llm_judge",
  "manager_agentic_llm_judge_categorical",
  "manager_agentic_llm_judge_numerical",
  "manager_default_categorical",
  "manager_agent_repeats_itself",
  "manager_numerical_llm_judge",
  "manager_persona_role_flip",
  "manager_composite_evaluation",
  "manager_persona_llm_binary",
  "manager_persona_default_categorical",
  "manager_persona_numerical_llm_judge",
  "manager_persona_agent_repeats_itself",
  "manager_rubric_decision_tree",
])

export function isLlmJudgeManager(metricManager: string | undefined): boolean {
  return metricManager !== undefined && LLM_JUDGE_MANAGERS.has(metricManager)
}
